module.exports = __webpack_public_path__ + "img/logo-paoli.115ed440.png";